import React, { useEffect, useState } from "react";
import SearchableSelect from "../Components/SearchableSelect";
import DateInput from "../Components/DateInput";
import TextInput from "../Components/TextInput";
import Button from "../Components/Button";
import RichTextBox from "../Components/RichTextBox";
import AlertToast from "../Components/AlertToast";

const SegnalazioneForm = ({ onSubmit }) => {
  const initialForm = {
    titoloSegnalazione: "",
    dataSegnalazione: "",
    condominoSegnalante: "",
    descrizioneSegnalazione: "",
    fornitoreId: "",
    dataAffidamento: "",
  };

  const [form, setForm] = useState(initialForm);
  const [alert, setAlert] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

    const handleSubmit = async (e) => {
      e.preventDefault();
      // Validazione base (puoi aggiungere altro)
        if (!form.dataSegnalazione || !form.condominoSegnalante || !form.titoloSegnalazione || !form.descrizioneSegnalazione) {
          alert("Compila almeno: Data segnalazione, Condomino segnalante, Titolo segnalazione, Descrizione segnalazione.");
          return;
      }
    try {
        const token = localStorage.getItem("token"); // o dove lo tieni tu
        const res = await fetch("https://api.lapegna.xyz/newsegnalazione", {
        method: "POST",
    
        headers: {"Content-Type": "application/json", Authorization: `Bearer ${token}`,},  
          body: JSON.stringify({
          Titolo: form.titoloSegnalazione,
          FK_CONDOMINIO: form.condominioId ? Number(form.condominioId) : null,
          DataSegnalazione: form.dataSegnalazione,
          Condomino: form.condominoSegnalante,
          Descrizione: form.descrizioneSegnalazione,
          DataAffidamento: form.dataAffidamento ? form.dataAffidamento : null,
          FK_FORNITORE: form.fornitoreId ? Number(form.fornitoreId) : null,
          }), 
        });

    if (!res.ok) {
      const errText = await res.text();
      throw new Error(errText || `Errore HTTP ${res.status}`);
    }

    const data = await res.json();
    setAlert({
      type: "success",
      message: "Segnalazione salvata correttamente",
    });
    setForm(initialForm);

  } catch (err) {
    setAlert({
      type: "error",
      message: "Errore durante il salvataggio",
    });
  }
  };

  {/* Carica fornitori per la combobox */}
  const [fornitori, setFornitori] = useState([]);
  const [loadingFornitori, setLoadingFornitori] = useState(false);
  useEffect(() => {
    const loadFornitori = async () => {
      try {
        setLoadingFornitori(true);
        const token = localStorage.getItem("token");
          const res = await fetch("https://api.lapegna.xyz/anafornitori", {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });

          if (!res.ok) throw new Error("Errore nel caricamento fornitori");
          const data = await res.json();
          setFornitori(data.fornitori);
         } catch (err) {
          console.error(err);
          alert("Errore nel caricamento fornitori");
        } finally {
          setLoadingFornitori(false);
        }
      };
      loadFornitori();
    }, []);


  {/* Carica condominii per la combobox */}
  const [condomini, setCondomini] = useState([]);
  const [loadingCondomini, setLoadingCondominii] = useState(false);
  useEffect(() => {
    const loadCondominii = async () => {
      try {
          setLoadingCondominii(true);
          const token = localStorage.getItem("token");
          const res = await fetch("https://api.lapegna.xyz/anacondominii", {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });

          if (!res.ok) throw new Error("Errore nel caricamento condomini");
          const data = await res.json();
          setCondomini(data.fornitori);
        } catch (err) {
          console.error(err);
          alert("Errore nel caricamento condomini");
        } finally {
          setLoadingCondominii(false);
        }
      };
      loadCondominii();
    }, []);


    return (
    <div style={{ maxWidth: 900, margin: "0 auto" }}>
      <h2>Nuova Segnalazione</h2>

      <form onSubmit={handleSubmit} style={{ display: "grid", gap: 12 }}>
        
       {/* Titolo segnalazione */}
        <TextInput
          label="Titolo segnalazione"
          name="titoloSegnalazione"
          value={form.titoloSegnalazione}
          onChange={handleChange}
          placeholder="Es. Perdita acqua nel vano scale"
        />
       
       
       {/* Combo Condominio filtrabile */}
        <label style={{ display: "grid", gap: 6 }}>
          <span style={{ color: "white" }}>Condominio</span>

          <SearchableSelect
            name="condominioId"
            value={form.condominioId}
            onChange={handleChange}
            disabled={loadingCondomini}
            placeholder={loadingCondomini ? "Caricamento..." : "-- Seleziona un condominio --"}
            options={condomini.map((c) => ({
              value: c.ID,
              label: c.DENOMINAZIONE,
            }))}
          />
        </label>

        
        {/* Data segnalazione */} 
        <DateInput
          label="Data segnalazione"
          name="dataSegnalazione"
          value={form.dataSegnalazione}
          onChange={handleChange}
          width="180px"   // oppure "100%"
        />


        {/* Condomino che ha segnalato */}
        <TextInput
          label="Condomino che ha segnalato"
          name="condominoSegnalante"
          value={form.condominoSegnalante}
          onChange={handleChange}
          placeholder="Es. Mario Rossi"
        />


        {/* descrizione della segnalazione (testo semplice) */}
        <RichTextBox
          label="Descrizione della segnalazione"
          name="descrizioneSegnalazione"
          value={form.descrizioneSegnalazione}
          onChange={handleChange}
          placeholder="Scrivi qui i dettagli..."
          minHeight={140}
          maxHeight={420}
        />

          
       {/* Data affidamento */}
        <DateInput
          label="Data affidamento"
          name="dataAffidamento"
          value={form.dataAffidamento}
          onChange={handleChange}
          width="180px"   // oppure "100%"
        />

        {/* Combo fornitore */}
        <label style={{ display: "grid", gap: 6 }}>
          <span style={{ color: "white" }}>Fornitore a cui è stata affidata la manutenzione</span>
          <SearchableSelect
            name="fornitoreId"
            value={form.fornitoreId}
            onChange={handleChange}
            disabled={loadingFornitori}
            placeholder={loadingFornitori ? "Caricamento..." : "-- Seleziona un fornitore --"}
            options={fornitori.map((f) => ({
              value: f.ID,
              label: f.DENOMINAZIONE,
            }))}
          />
        </label>

        <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
          <Button type="submit">Salva</Button>
          <Button variant="danger" onClick={() => setForm(initialForm)}>Svuota</Button>
        </div>

        <AlertToast
          message={alert?.message}
          type={alert?.type}
          onClose={() => setAlert(null)}
        />

      </form>
    </div>
);
};

export default SegnalazioneForm;

